import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SeguridadService } from '../servicios/seguridad.service';

@Directive({
  selector: '[appIsLogin]'
})
export class IsLoginDirective {

  private isLogin = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private seguridadService: SeguridadService
  ) { }

  @Input()
  set appIsLogin(value: boolean) {
    this.isLogin = value;
    this.updateView();
    this.seguridadService.getAutenticacion().subscribe(() => this.updateView());
  }

  private updateView(): void {
    this.viewContainerRef.clear();
    if (this.isLogin) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }


}
